import { getbookcate } from "@/request/api";

const state = {
  bookCate: [],
};

const mutations = {
  SET_BOOK_CATE(state, list) {
    state.bookCate = list;
  },
};

const actions = {
  async fetchBookCate({ commit }) {
    try {
      const res = await getbookcate();
      if (res.resultCode === 0) {
        commit("SET_BOOK_CATE", res.result.data);
      } else {
        console.warn("获取书籍分类失败：", res.errorMsg || "获取数据失败");
      }
    } catch (err) {
      console.error("获取书籍分类接口异常：", err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/book.js